export const ROUTES = {
  HOME: "/",
  SIGNIN: "/entrar",
  SIGNUP:"/cadastrar",
  FORGOT_PASSWORD: "/esqueci-minha-senha",
  RESET_PASSWORD: "/recuperar-senha",
  CHANGE_PASSWORD: "/trocar-senha",
  USER_PROFILE: "/perfil",
  EDIT_PROFILE: "/editar-perfil",
  EDIT_DOCTOR_PROFILE: "/editar-perfil-medico",
  USERINFO:"/Usuario/:id",
  MY_APPOINTMENTS: "/meus-agendamentos",
  DASHBOARD: "/dashboard",
  SCHEDULE: "/agenda",
  REPORTS: "/relatorios",
  USERS_LIST: "/usuarios",
  AUDIT_LOGS: "/auditoria",
  NOTIFICATIONS: "/notificacoes",
  FINANCE: "/financeiro",
  TERMS_OF_USE: "/termos-de-uso",
  PRIVACY_POLICY: "/politica-de-privacidade",
  MEDICAL_RECORD: "/prontuario/:id",
  MEDICAL_RECORD_NEW: "/prontuario/novo",
  PATIENT_HISTORY: "/paciente/:patientId/historico",
  MY_MEDICAL_RECORDS: "/meus-prontuarios",
  PRESCRIPTION_TEMPLATES: "/meus-prontuarios/modelos",
};
